import { render, staticRenderFns } from "./ProductEditGroups.vue?vue&type=template&id=1a9c6274"
import script from "./ProductEditGroups.vue?vue&type=script&lang=ts"
export * from "./ProductEditGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports